import Moment from 'moment-mini';
Moment.suppressDeprecationWarnings = true;

export default {
  filters : {
    unixToShortDate : function(value){
      return Moment.unix(value).format("DD-MM-YYYY"); //HH:MM
    },
    unixToMediumDate : function(value){
      return Moment.unix(value).format("DD-MM-YYYY HH:mm"); //HH:MM:ss
    },
    unixToLongDate : function(value){
      return Moment.unix(value).toString();
    },
    formatMoney : function(value){
      return parseFloat(value).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
    },
    upperCase : function(value){
      return String(value).toUpperCase();
    },
    serializeSupplyTitle : function(value){
      return String(value).replace(/[^0-9a-z]/gi, '').toLowerCase();
    },
    addressJsonToInline : function(value){
      let address_json = JSON.parse(value);
      let address_arr = [];
      Object.keys(address_json).forEach((a) => {
        address_arr.push(address_json[a]);
      });
      return address_arr.join(`, `);
    }
  },
  methods : {
    callAPI : function(verb, endpoint, payload, headers){
      payload = (!payload ? {} : payload);
      verb = verb.toLowerCase();
      if(verb === 'get'){
        payload = { params : payload }
        if(headers){
          payload.headers = headers;
          headers = null;
        }
      }
      return new Promise((resolve, reject) => {
        this.$http[verb](endpoint, payload, headers)
          .then((res) => {
            const content_type = res.headers.get('content-type');
            if(content_type === `application/pdf`){
              const blob = new Blob([res.body], { type:res.headers.get('content-type') });
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.target = '_blank';
              // link.download = "invoices.pdf";
              link.click();
            } else if(res.body.status === 'success'){
              resolve(res.body);
            } else {
              reject(res.body.message);
            }
          }, (err) => {
            reject(err);
          }
        );
      });
    },
    getPrinterCode : function(type){
      // TODO move links between location and printer code to the database.
      // cjjh7w3bz0nmozpx04bkilzvz1 plant room
      // cjjh7w3bz0nmozpx04bkilzvz2 dispatch
      let loc = this.$store.getters.user.location;
      switch(type){
        case 'tray':
          if(loc === 'cjjh7w3bz0nmozpx04bkilzvz1'){ return 'rmstc'; }
          else { return 'rmst'; }
          break;
        case 'product':
          return 'rmsp';
          break;
        case 'recipe':
          return 'rmsp';
          break;
        default:
          return 0;
          break;
      }
    },
    printLbl : function(payload, printer, event_detail){
      let _self = this;
      if(!event_detail || event_detail == 1){ // prevent double click
        // payload.location = _self.$store.getters.printer_location;
        setTimeout(() => {
          console.log('Printing to '+ this.$store.getters.printer_uri +'/label/'+ printer);
          // http://212.159.121.4:3040/label/product/rmsp
          _self
            .callAPI("post", _self.$store.getters.printer_uri + `/label/${printer}`, payload, { 'Content-Type': 'application/x-www-form-urlencoded' })
            .then(res => {
              console.log(res);
            })
            .catch(err => {
              console.error(err);
            });
        }, 2000);
      }
    },
    pageChange : function(page_number){
      this.current_page = page_number;
      this.getData(page_number);
    },
    processPages : function(count){
      if(count > 0){
        this.total = count;
        this.pages = Math.ceil(count / 20);
      } else {
        this.total = 0;
        this.pages = 0;
      }
    },
    getNow : function(){
      return Moment().unix();
    },
    sortTable : function(column_number, table_id, is_numeric){
      let table       = document.getElementById(table_id);
      let dir         = "asc";
      let switching   = true;
      let switchcount = 0;
      let comp_result = false;
      let rows, i, x, y, shouldSwitch;
      while(switching){ // loop until no switching has been done:
        switching = false;
        rows = table.rows;
        for(i = 1; i < (rows.length - 1); i++){ // Start at 1 because row 0 contains table headers
          shouldSwitch = false;
          x = rows[i].getElementsByTagName("TD")[column_number].innerHTML; // Current row
          y = (typeof rows[i + 1].getElementsByTagName("TD")[column_number] !== 'undefined' ? rows[i + 1].getElementsByTagName("TD")[column_number].innerHTML : null); // Next row
          x = (is_numeric ? parseFloat(x) : x.toLowerCase());
          y = (is_numeric ? parseFloat(y) : y.toLowerCase());
          comp_result = (dir === 'desc' ? x < y : x > y); // Assume ascending if not explicitly descending
          if(comp_result){
            shouldSwitch = true;
            break;
          }
        }
        if(shouldSwitch){
          rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
          switching = true;
          switchcount += 1; // Each time a switch is done, increase this count by 1:
        } else {
          if(switchcount === 0 && dir === "asc"){
            dir = "desc";
            switching = true;
          }
        }
      }
    },
    isObjectEqual : (obj1, obj2) => {
      // console.log({ obj1 });
      // console.log({ obj2 });
      const obj1Keys = Object.keys(obj1);
      const obj2Keys = Object.keys(obj2);
      if(obj1Keys.length !== obj2Keys.length){
        return false; // Keys don't match, reject
      }
      for(let objKey of obj1Keys){
        if(obj1[objKey] !== obj2[objKey]){
          return false; // Keys match, but value of at one of those keys do not
        }
      }
      return true;
    },
    prepareNewModal : function(modal_title){
      this.edit        = {};
      this.edit.idx    = -1;
      this.modal_title = modal_title;
    },
    prepareEditModal : function(idx, modal_title){
      Object.assign(this.edit, this.data[idx]);
      this.edit.idx    = idx;
      this.modal_title = modal_title;
    },
    prepareEditInvoiceModal : function(idx, modal_title){
      Object.assign(this.edit, this.data[idx]);
      this.edit.invoice_date = Moment.unix(this.edit.invoice_date).format("YYYY-MM-DD");
      this.edit.gi_date = Moment.unix(this.edit.gi_date).format("YYYY-MM-DD");
      this.edit.idx    = idx;
      this.modal_title = modal_title;
    },
    areYouSureDialog : function(fn){
      if(confirm("Are you sure you want to do this?")){
        fn();
      }
    },
    datePickerFormatter : function(date){
      return Moment(date).format('YYYY-MM-DD');
    },
    datepickerChangedMonth : function(){
      event.preventDefault();
    },
    parseDateToUnix : function(d, hours){
      if(hours){
        return (typeof d === 'object' ? Moment(d).hours(hours).unix() : Moment(d, 'YYYY-MM-DD').hours(hours).unix());
      } else {
        return (typeof d === 'object' ? Moment(d).startOf('day').unix() : Moment(d, 'YYYY-MM-DD').startOf('day').unix());
      }
      // if(typeof d === 'object'){
      //   return Moment(d).unix();
      // } else {
      //   return Moment(d, 'YYYY-MM-DD').unix();
      // }
    },
    unixToDate : function(value){
      return Moment.unix(value).format("DD-MM-YYYY HH:MM");
    },
    unixToJustDate : function(value){
      return Moment.unix(value).format("DD-MM-YYYY");
    },
    unixToExpandedDate : function(value){
      return Moment.unix(value).format("D MMMM YYYY");
    },
    getCompressedDateNow : function(){
      return Moment().format("DMYHms");
    },
    formatMoney : function(value){
      return parseFloat(value).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
    },
    formatName : function(str){
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/mixins.js